/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
/* eslint-disable prefer-rest-params */
/* eslint-disable func-names */

// This fix is required because of a fundmental problem in the interaction between
// Google Translate and React.
// More details here: https://github.com/facebook/react/issues/11538

const applyGoogleTranslateFix = () => {
  if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function (child) {
      if (child.parentNode !== this) {
        if (console) {
          console.error('Cannot remove a child from a different parent', child, this);
        }
        return child;
      }
      return (originalRemoveChild.apply as any)(this, arguments);
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function (newNode, referenceNode) {
      if (referenceNode && referenceNode.parentNode !== this) {
        if (console) {
          console.error(
            'Cannot insert before a reference node from a different parent',
            referenceNode,
            this,
          );
        }
        return newNode;
      }
      return (originalInsertBefore.apply as any)(this, arguments);
    };
  }
};

export default applyGoogleTranslateFix;
